var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_121070",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_121070)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "badge",
    d: "M5.58331 28C5.02081 28 4.53297 27.7934 4.11978 27.3802C3.70659 26.967 3.5 26.4792 3.5 25.9167V11.3333C3.5 10.7708 3.70659 10.283 4.11978 9.86978C4.53297 9.45659 5.02081 9.25 5.58331 9.25H12.875V5.08331C12.875 4.52081 13.0816 4.03297 13.4948 3.61978C13.908 3.20659 14.3987 3 14.9669 3H17.0331C17.6013 3 18.092 3.20659 18.5052 3.61978C18.9184 4.03297 19.125 4.52081 19.125 5.08331V9.25H26.4167C26.9792 9.25 27.467 9.45659 27.8802 9.86978C28.2934 10.283 28.5 10.7708 28.5 11.3333V25.9167C28.5 26.4792 28.2934 26.967 27.8802 27.3802C27.467 27.7934 26.9792 28 26.4167 28H5.58331ZM5.58331 25.9167H26.4167V11.3333H19.125V11.9583C19.125 12.5764 18.9184 13.0781 18.5052 13.4635C18.092 13.8489 17.6013 14.0417 17.0331 14.0417H14.9669C14.3987 14.0417 13.908 13.8489 13.4948 13.4635C13.0816 13.0781 12.875 12.5764 12.875 11.9583V11.3333H5.58331V25.9167ZM8.33334 22.8542H15.8125V22.375C15.8125 22.0069 15.717 21.6753 15.526 21.3802C15.3351 21.0851 15.0833 20.875 14.7708 20.75C14.1875 20.5347 13.6996 20.3872 13.3073 20.3073C12.9149 20.2274 12.5208 20.1875 12.125 20.1875C11.7014 20.1875 11.2691 20.2344 10.8281 20.3281C10.3871 20.4219 9.90971 20.5625 9.39581 20.75C9.06944 20.875 8.81076 21.0851 8.61978 21.3802C8.42882 21.6753 8.33334 22.0069 8.33334 22.375V22.8542ZM18.6667 20.8333H23.875V19.1667H18.6667V20.8333ZM12.125 19.1667C12.6111 19.1667 13.0243 18.9965 13.3646 18.6562C13.7049 18.316 13.875 17.9028 13.875 17.4167C13.875 16.9306 13.7049 16.5174 13.3646 16.1771C13.0243 15.8368 12.6111 15.6667 12.125 15.6667C11.6389 15.6667 11.2257 15.8368 10.8854 16.1771C10.5451 16.5174 10.375 16.9306 10.375 17.4167C10.375 17.9028 10.5451 18.316 10.8854 18.6562C11.2257 18.9965 11.6389 19.1667 12.125 19.1667ZM18.6667 17.2292H23.875V15.5625H18.6667V17.2292ZM14.9583 11.9583H17.0417V5.08331H14.9583V11.9583Z",
    fill: "#054BC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconBlue);
export default __webpack_public_path__ + "static/media/contact-icon-blue.d2093c182606d960dba4efb3c2ce70e3.svg";
export { ForwardRef as ReactComponent };